import {ASync} from "../PA.Core/Basic/ASync";
import {IPolicy} from "../PA.Core/PA.Core.IF.Policy";
import {BehaviorSubject} from "rxjs";
import {UserSecurityService} from "../PA.Security.Services/UserSecurityService";
import * as _ from 'lodash'
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import {IUsrContext} from "../PA.Core/PA.Core.IF.User";
import {Role_TPM_Payment_Editor, Role_TPM_Event_Approver, Role_TPM_Event_Editor} from "../PA.Core/Security/Roles";
import {ILock} from "../PA.Concurrency.Core/PA.Concurrency.IF.Lock";
import {Subscription} from "rxjs/Subscription";
import {PaymentBO} from "./PaymentBO";
import {WB_PaymentTypeRow} from "../PA.Core/PAdbSchemaRows";

export class PaymentBOStandardPolicy
    implements
        IPolicy
{
    _payment: PaymentBO
    _pmtType: WB_PaymentTypeRow
    _PolicyChanged: BehaviorSubject<IPolicy>
    _onLockPropertyChanged: Subscription
    _isApprover: boolean
    _isEditor: boolean
    _isClosedOrCancelled: boolean
    _isPostApproval: boolean
    _isPreApproval: boolean
    _isLoaded: boolean
    _Lock: ILock

    constructor(payment: PaymentBO, aLock?: ILock) {
        this._payment = payment
        this._pmtType = payment.WB_Payment.WB_PaymentTypeRow
        this._PolicyChanged = new BehaviorSubject<IPolicy>(this)
        this._isApprover = false
        this._isEditor = false
        this._isClosedOrCancelled = false
        this._isPostApproval = false
        this._isPreApproval = false
        this._isLoaded = false

        this._Lock = aLock

        if (!_.isEmpty(aLock)) {
            this._onLockPropertyChanged = aLock.OnPropertyChanged.subscribe(x => this._PolicyChanged.next(this))
        }
    }

    get OnLoadComplete(): Promise<void> {
        const self = this

        if(self._isLoaded){ return ASync.resolve() }
        let wbCustomerId = 0
        return new Promise<void>((resolve, error) => {
            self._payment.OnLoadComplete
                .then((ignore:any) => {
                    wbCustomerId = self._payment.WB_Payment.cif.WB_CUST_ID_FUNDING || self._payment.WB_Payment.cif.WB_CUST_ID_PLANNING
                    let currentState = self._payment.PrimaryWorkflowProcessor.CurrentState
                    self._isClosedOrCancelled =  currentState.StatusTypeClosed || currentState.StatusTypeCancelled
                    self._isPostApproval = currentState.StatusTypeIsPostApproval
                    self._isPreApproval = currentState.StatusTypeIsPreApproval
                    return UserSecurityService.getCustomerList([Role_TPM_Payment_Editor])
                })
                .then((arrCustomerLists: number[]) => {
                    let usrContext: IUsrContext = PAEnvironment.getValue(PAEnvironment.UserContext)

                    if(_.includes(arrCustomerLists, self._payment.WB_Payment.cif.WB_PLNMGMT_ID) && usrContext){
                        self._isEditor =  usrContext.hasRoleId(Role_TPM_Event_Editor, wbCustomerId)
                        self._isApprover = usrContext.hasRoleId(Role_TPM_Event_Approver, wbCustomerId)
                    } else {
                        self._isApprover = false
                        self._isEditor = false
                    }
                    self._isLoaded = true
                    self._PolicyChanged.next(self)
                })
                .catch((err:any) => {
                    self._isApprover = false
                    self._isEditor = false
                    self._PolicyChanged.next(self)
                })
            //
            resolve()
        })
    }

    get bIsApprover(): boolean {
        return this._isApprover
    }

    get bIsEditor(): boolean {
        return this._isEditor
    }

    get bIsClosedOrCancelled(): boolean {
        return this._isClosedOrCancelled
    }

    get bIsPreApproval(): boolean {
        return this._isPreApproval
    }

    get bIsPostApproval(): boolean {
        return this._isPostApproval
    }

    // Add Editbility/ Visibility Properties for all the Elements of an Event
    get bNameEditable(): boolean{
        return this.bIsEditor && !this.bIsClosedOrCancelled
    }

    get bPlanningCustomerVisible(): boolean{
        return this._pmtType.bShowPlanningCustomer
    }


    get bSubPlanningCustomerEditable(): boolean {
        return this.bIsEditor && !this.bIsClosedOrCancelled
    }

    get bSubPlanningCustomerVisible(): boolean {
        return false
        // this._pmtType.bShow
    }


    get bWorkflowHistoryTabVisible(): boolean {
        return this.bIsPostApproval || this.bIsClosedOrCancelled
    }

    get PolicyChanged(): BehaviorSubject<IPolicy> {
        return this._PolicyChanged
    }

}


